var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimplifiedRenovation1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1043_4858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 64,
    height: 64,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1067 29.5361C47.0036 29.5361 56.2133 27.8011 56.2133 23.7681C56.2133 20.6418 49.7531 18 42.1067 18C34.4602 18 28 20.6418 28 23.7681C28 26.8944 34.4602 29.5361 42.1067 29.5361ZM41.5212 19.7391C41.6488 19.4795 41.8508 19.2563 42.1067 19.0907C42.3131 18.9561 42.55 18.8641 42.8004 18.821C43.0508 18.7779 43.3087 18.785 43.5558 18.8416C45.1878 19.1743 46.7443 19.756 48.1578 20.5616C49.6557 21.4718 51.0715 23.0021 50.2193 24.4135C48.5188 27.2289 42.0874 27.2289 42.0868 27.2289C38.9006 27.2289 33.7709 26.227 33.7709 23.4797C33.7709 21.4424 37.0693 19.87 41.5212 19.7391Z",
    fill: "url(#paint0_linear_1043_4858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9177 26.0351L41.3275 20.9015C37.5962 21.063 35.0538 22.3395 35.0538 23.4798C35.0538 24.5706 37.384 25.8049 40.9177 26.0351ZM45.773 20.7169C44.9505 20.4068 44.1027 20.1542 43.237 19.9613C43.1705 19.9477 43.1015 19.9472 43.0347 19.9598C42.9679 19.9724 42.905 19.9978 42.8501 20.0344C42.7953 20.0709 42.75 20.1177 42.7171 20.1715C42.6843 20.2253 42.6648 20.2848 42.6599 20.346V20.357L42.1989 26.0755C43.3073 26.0769 44.4123 25.9639 45.4921 25.7386L45.773 20.7169ZM44.672 23.7682C44.672 23.9212 44.6045 24.0679 44.4842 24.1761C44.364 24.2843 44.2009 24.345 44.0308 24.345C43.8607 24.345 43.6977 24.2843 43.5774 24.1761C43.4572 24.0679 43.3896 23.9212 43.3896 23.7682V23.1914C43.3896 23.0385 43.4572 22.8917 43.5774 22.7836C43.6977 22.6754 43.8607 22.6146 44.0308 22.6146C44.2009 22.6146 44.364 22.6754 44.4842 22.7836C44.6045 22.8917 44.672 23.0385 44.672 23.1914V23.7682ZM49.0598 23.9194C49.4997 23.0853 48.2904 22.0361 47.4389 21.5175C47.3035 21.4354 47.1656 21.3567 47.0253 21.2816L46.7957 25.3833C47.9967 24.9795 48.761 24.4864 49.0598 23.9194ZM43.6826 46.0116C43.5131 45.9002 43.3195 45.822 43.1142 45.7822C42.909 45.7425 42.6967 45.742 42.4913 45.7809C41.7729 45.8771 41.0413 45.7168 40.4526 45.3341C39.8639 44.9515 39.465 44.377 39.341 43.7332C39.3176 43.5458 39.2508 43.3648 39.1449 43.202C39.0391 43.0391 38.8965 42.898 38.7263 42.7878C38.5562 42.6775 38.3622 42.6006 38.157 42.5618C37.9517 42.5231 37.7398 42.5235 37.5347 42.5629C36.8724 42.6535 36.1962 42.5241 35.6322 42.1989C35.0545 42.5646 34.4896 42.92 33.9375 43.2655C33.7741 43.368 33.6394 43.5034 33.5443 43.6609C33.4492 43.8184 33.3961 43.9936 33.3894 44.1728C33.3827 44.3519 33.4225 44.53 33.5056 44.6929C33.5887 44.8558 33.7129 44.999 33.8682 45.1112L40.3118 49.7459C40.5328 49.9056 40.8064 49.9949 41.0898 49.9999C41.3732 50.0049 41.6505 49.9253 41.8783 49.7736C42.8199 49.1416 43.7477 48.4931 44.6611 47.8286C44.4929 47.5551 44.371 47.2606 44.2995 46.9547C44.2759 46.7674 44.2088 46.5866 44.1025 46.4242C43.9963 46.2617 43.8532 46.1211 43.6826 46.0116ZM40.6843 47.7778C40.6317 47.837 40.5666 47.8863 40.4929 47.9228C40.4191 47.9594 40.338 47.9825 40.2543 47.9908C40.1706 47.9992 40.0858 47.9926 40.0049 47.9715C39.924 47.9504 39.8485 47.9152 39.7828 47.8678L36.5767 45.5606C36.4439 45.465 36.3587 45.3258 36.34 45.1737C36.3212 45.0216 36.3704 44.8691 36.4767 44.7496C36.583 44.6301 36.7377 44.5535 36.9067 44.5366C37.0758 44.5198 37.2454 44.564 37.3782 44.6596L40.5843 46.9668C40.6501 47.0142 40.7049 47.0727 40.7455 47.1391C40.7861 47.2054 40.8118 47.2784 40.8211 47.3537C40.8304 47.429 40.8231 47.5052 40.7996 47.578C40.7762 47.6508 40.737 47.7187 40.6843 47.7778Z",
    fill: "url(#paint1_linear_1043_4858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3593 20.7384C55.7781 20.2682 55.1254 19.8747 54.421 19.5698C56.1086 20.5781 57.5251 22.0166 57.4949 23.8307C57.4371 24.8774 56.965 25.8709 56.1638 26.6317C52.8776 30.7085 44.1616 36.7419 36.8633 41.4141C37.0556 41.4308 37.248 41.4296 37.4404 41.4112C38.1571 41.3113 38.8888 41.4691 39.4774 41.8504C40.066 42.2316 40.4642 42.8059 40.5862 43.449C40.6107 43.6369 40.6783 43.8182 40.7847 43.9813C40.8911 44.1445 41.0339 44.286 41.2042 44.397C41.3745 44.508 41.5686 44.586 41.7741 44.626C41.9796 44.6661 42.1921 44.6674 42.3982 44.6298C43.1154 44.5331 43.8461 44.6928 44.434 45.0746C45.0219 45.4564 45.4203 46.0301 45.544 46.6728C45.5793 46.8084 45.6242 46.9422 45.678 47.0731C46.6211 46.3697 47.5476 45.6485 48.457 44.9101L45.5363 42.664C45.4723 42.6148 45.4197 42.5547 45.3816 42.4872C45.3434 42.4196 45.3204 42.346 45.3138 42.2705C45.3073 42.195 45.3173 42.119 45.3434 42.047C45.3695 41.975 45.4111 41.9083 45.4658 41.8507C45.5205 41.7931 45.5873 41.7458 45.6624 41.7115C45.7374 41.6772 45.8193 41.6564 45.9032 41.6506C45.9872 41.6447 46.0716 41.6537 46.1517 41.6772C46.2317 41.7006 46.3059 41.738 46.3699 41.7873L49.3983 44.1187C50.2924 43.3695 51.1674 42.6022 52.0228 41.8173L49.383 39.7794C49.3154 39.7312 49.2593 39.6712 49.2181 39.6031C49.1769 39.5349 49.1514 39.46 49.1431 39.3828C49.1349 39.3056 49.144 39.2276 49.17 39.1537C49.196 39.0797 49.2383 39.0112 49.2944 38.9523C49.3505 38.8934 49.4192 38.8452 49.4964 38.8108C49.5737 38.7763 49.6579 38.7562 49.744 38.7516C49.8301 38.7471 49.9163 38.7583 49.9975 38.7844C50.0787 38.8106 50.1532 38.8512 50.2165 38.9038L52.9096 40.9803C53.5749 40.3506 54.2261 39.7088 54.8628 39.0555C55.0288 38.8825 55.1987 38.7094 55.37 38.5306L53.4585 36.5643C53.4026 36.5073 53.3597 36.441 53.3324 36.3691C53.3051 36.2971 53.2938 36.2211 53.2993 36.1452C53.3047 36.0694 53.3268 35.9953 53.3642 35.9271C53.4016 35.859 53.4536 35.7982 53.5172 35.7481C53.5808 35.6981 53.6548 35.6599 53.7349 35.6357C53.815 35.6115 53.8996 35.6018 53.9839 35.6071C54.0682 35.6124 54.1504 35.6326 54.226 35.6666C54.3016 35.7006 54.3689 35.7477 54.4242 35.8052L56.2125 37.6423C56.9684 36.8377 57.6584 35.9849 58.2772 35.0905L57.0006 33.4755C56.9517 33.4137 56.9169 33.344 56.898 33.2701C56.8792 33.1963 56.8766 33.1198 56.8906 33.0451C56.9046 32.9704 56.9348 32.8989 56.9796 32.8346C57.0243 32.7704 57.0826 32.7148 57.1512 32.6708C57.2199 32.6269 57.2974 32.5956 57.3795 32.5786C57.4616 32.5616 57.5466 32.5594 57.6297 32.572C57.7128 32.5846 57.7922 32.6117 57.8636 32.652C57.935 32.6922 57.9969 32.7447 58.0457 32.8064L58.9575 33.96C59.4099 33.133 59.7158 32.2475 59.8642 31.3355C60.374 27.9151 59.4904 23.3121 56.3593 20.7384Z",
    fill: "url(#paint2_linear_1043_4858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7709 37.6116V34.7276C33.7709 34.5746 33.8385 34.4279 33.9587 34.3197C34.079 34.2115 34.2421 34.1508 34.4121 34.1508C34.5822 34.1508 34.7453 34.2115 34.8655 34.3197C34.9858 34.4279 35.0533 34.5746 35.0533 34.7276V37.9577C36.1068 38.2126 37.1777 38.4041 38.2594 38.531V35.3044C38.2594 35.1514 38.327 35.0047 38.4472 34.8965C38.5675 34.7883 38.7305 34.7276 38.9006 34.7276C39.0707 34.7276 39.2338 34.7883 39.354 34.8965C39.4743 35.0047 39.5418 35.1514 39.5418 35.3044V38.242C43.8882 35.4303 48.0404 32.3833 51.9756 29.1181C48.8281 30.2054 45.4778 30.739 42.1067 30.6899C35.7157 30.6899 30.3532 29.0212 28 26.5796V32.9971C28 34.0094 28.7053 34.9865 29.9236 35.8414V32.9971C29.9236 32.8442 29.9912 32.6975 30.1114 32.5893C30.2317 32.4811 30.3948 32.4203 30.5648 32.4203C30.7349 32.4203 30.898 32.4811 31.0183 32.5893C31.1385 32.6975 31.2061 32.8442 31.2061 32.9971V36.6016C32.0256 37.0068 32.884 37.3448 33.7709 37.6116Z",
    fill: "url(#paint3_linear_1043_4858)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1043_4858",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1043_4858"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_4858"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1043_4858"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1043_4858",
    result: "effect2_dropShadow_1043_4858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1043_4858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_4858",
    x1: 28,
    y1: 23.7681,
    x2: 56.2133,
    y2: 23.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_4858",
    x1: 33.3887,
    y1: 34.9754,
    x2: 49.1533,
    y2: 34.9754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1043_4858",
    x1: 36.8633,
    y1: 33.3215,
    x2: 59.9993,
    y2: 33.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1043_4858",
    x1: 28,
    y1: 32.5553,
    x2: 51.9756,
    y2: 32.5553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplifiedRenovation1);
export default __webpack_public_path__ + "static/media/Simplified Renovation1.336b8d543d6a9847a3062b4abe2c696f.svg";
export { ForwardRef as ReactComponent };